import { render, staticRenderFns } from "./Setname.vue?vue&type=template&id=118e888c&scoped=true&"
import script from "./Setname.vue?vue&type=script&lang=js&"
export * from "./Setname.vue?vue&type=script&lang=js&"
import style0 from "./Setname.vue?vue&type=style&index=0&id=118e888c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118e888c",
  null
  
)

export default component.exports